import { Checkbox, Divider, FormControlLabel } from "@material-ui/core";
import { ListFilterState, TableFilterAction } from "./models";
import useStyles from "./styles";
import UncheckedCheckbox from "../icons/Controls/UncheckedCheckbox";
import CheckedCheckbox from "../icons/Controls/CheckedCheckbox";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FlexierTypography } from "./FlexierTypography";
import CheckboxIcon from "../icons/CheckboxIcon";

type SelectAllCheckboxProps = {
	filter: ListFilterState;
	dispatcher: (action: TableFilterAction) => void;
};

type SelectState = "unchecked" | "indeterminate" | "checked";

const SelectAllCheckbox = ({ filter, dispatcher }: SelectAllCheckboxProps) => {
	const { t } = useTranslation();
	const { divider, selectAllItemControl, ellipsisRule, fullWidth } = useStyles();

	const selectAllState: SelectState = useMemo(() => {
		const total = filter.options.length;
		const selected = filter.options.filter((option) => option.isSelected).length;
		if (selected === 0) {
			return "unchecked";
		}
		if (total === selected) {
			return "checked";
		}
		return "indeterminate";
	}, [filter]);

	if (!filter.isMulti || filter.options.length === 0) {
		return null;
	}

	return (
		<>
			<FormControlLabel
				control={
					<Checkbox
						icon={<CheckboxIcon />}
						checked={selectAllState !== "unchecked"}
						indeterminate={selectAllState === "indeterminate"}
						className={selectAllItemControl}
					/>
				}
				onChange={() =>
					dispatcher({
						type: selectAllState === "checked" ? "clear-selection" : "select-current-scope",
						path: filter.field as string,
					})
				}
				label={
					<FlexierTypography className={ellipsisRule} color={selectAllState === "checked" ? "primary" : undefined}>
						{t("indications-select-all")}
					</FlexierTypography>
				}
				classes={{ root: fullWidth, label: fullWidth }}
			/>
			<Divider className={divider} />
		</>
	);
};

export default SelectAllCheckbox;
